import { useState, useCallback } from 'react';
import ScontiService from '../services/ScontiService/ScontiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useSconti = () => {
    const [loadingState, setLoadingState] = useState({
        isLoadingSconti: false,
        isLoadingScontoCreating: false,
        isLoadingScontoDeleting: false,
        isLoadingScontoByIdCorso: false,
        isLoadingVoucherByIdCorso: false
    });

    const [modalState, setModalState] = useState({
        showModalCreateSconto: false
    });

    const getScontiByIdAgenzia = useCallback(async (id_agenzia) => {
        setLoadingState(prev => ({ ...prev, isLoadingSconti: true }));
        try {
            const response = await ScontiService.getScontiByIdAgenzia(id_agenzia);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (err) {
            handleError(err);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingSconti: false }));
        }
    }, []);

    // --- NUOVA FUNZIONE AGGIUNTA ---
    const getScontiByIdSuperpartner = useCallback(async (id_superpartner) => {
        setLoadingState(prev => ({ ...prev, isLoadingSconti: true }));
        try {
            // Chiama un nuovo metodo del servizio che creeremo nel backend
            const response = await ScontiService.getScontiByIdSuperpartner(id_superpartner);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (err) {
            handleError(err);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingSconti: false }));
        }
    }, []);
    // --- FINE NUOVA FUNZIONE ---

    const createSconto = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isLoadingScontoCreating: true }));
        try {
            const response = await ScontiService.createSconto(data);
            alertService.success("Sconto assegnato con successo", {autoClose: true});
            return response;
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingScontoCreating: false }));
        }
    }, []);

    const deleteSconto = useCallback(async (id_sconto) => {
        setLoadingState(prev => ({ ...prev, isLoadingScontoDeleting: true }));
        try {
            await ScontiService.deleteSconto(id_sconto);
            alertService.success("Sconto eliminato con successo", {autoClose: true});
            return true;
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingScontoDeleting: false }));
        }
    }, []);

    const getScontoByIdCorso = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isLoadingScontoByIdCorso: true }));
        try {
            const response = await ScontiService.getScontoByIdCorso(data);
            return response;
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingScontoByIdCorso: false }));
        }
    }, []);
    
    // Funzioni esistenti per superpartner (logica diversa, mantenute)
    const getScontiSuperPartner = useCallback(async (params) => {
        try {
            const response = await ScontiService.getScontiSuperPartner(params);
            return response;
        } catch(e) { handleError(e); return []; }
    }, []);

    const createScontoSuperPartner = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isLoading: true }));
        try {
            await ScontiService.createScontoSuperPartner(data);
            return true;
        } catch(e) { handleError(e); return false; }
        finally { setLoadingState(prev => ({ ...prev, isLoading: false })); }
    }, []);

    const deleteScontoSuperPartner = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isLoading: true }));
        try {
            await ScontiService.deleteScontoSuperPartner(data);
            return true;
        } catch(e) { handleError(e); return false; }
        finally { setLoadingState(prev => ({ ...prev, isLoading: false })); }
    }, []);

    return {
        loadingStateSconti: loadingState,
        modalStateSconti: modalState,
        setModalStateSconti: setModalState,
        getScontiByIdAgenzia,
        getScontiByIdSuperpartner, // Esportiamo la nuova funzione
        createSconto,
        deleteSconto,
        getScontoByIdCorso,
        getScontiSuperPartner,
        createScontoSuperPartner,
        deleteScontoSuperPartner
    };
};

export default useSconti;